import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { useRef } from "react";
import { URLS } from "../../Services/Constant";
import { get, post, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";

const WalletTransactionadd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type;
  const setReject = location.state?.setReject;
  const useData = location.state?.userDatas;
  const isReject = location.state?.isReject;

  const [showReason, setShowReason] = useState(isReject || false);
  const isViewMode = formType === "view" || (formType === "edit" && !setReject);
  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [isUserDropdownList, setuserDropdownList] = useState([]);
  const [isuserBooking, setisuserBooking] = useState([]);
  const admin_details = JSON.parse(localStorage.getItem("admin_details"));

  const [userSearch, setUserSearch] = useState("");
  const [currentDropLimit, setCurrentDropLimit] = useState(100);

  const filteredUsers = useMemo(() => {
    if (!userSearch || userSearch.length < 2) {
      return [];
    }

    const search = userSearch.toLowerCase();

    return isUserDropdownList
      .filter((user) => user.label.toLowerCase().includes(search))
      .slice(0, 100);
  }, [isUserDropdownList, userSearch]);

  const UsersDropdown = useMemo(() => {
    return isUserDropdownList.slice(
      0,
      currentDropLimit,
    );
  }, [isUserDropdownList, currentDropLimit]);

  const inputRef = useRef(null);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    resetField,
    onReset,
    reset,
  } = useForm({
    defaultValues: {
      userName: "",
      email: "",
      mobile: "",
      whatsapp: "",
      gender: null,
      nationality: "India",
      state: null,
      city: null,
      area: null,
      googleAddress: "",
      manualAddress: "",
    },
  });
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2)
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3)
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };
  const userDropdownListGET = useCallback(async (locationType, parent_id) => {
    try {
      const url = `${URLS.USERLIST_DROPDOWN}`;
      const res = await get(url);
      if (res?.status === "success") {
        const formatted = res?.data.map((item) => ({
          value: item.id,
          label: `${item.name} - ${item.code}`,
        }));

        setuserDropdownList(formatted);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, []);
  const userBookingDropdown = useCallback(async ({ state, city, user }) => {
    try {
      console.log("state, city, Use", state, city, user);
      const baseUrl = `${URLS.USER_WALLET_BOOKING}`;
      const query = new URLSearchParams({ state, city, user });
      const url = `${baseUrl}?${query.toString()}`;

      const res = await get(url);
      if (res?.status === "success") {
        console.log(
          "SADJLAS2",
          res,
          "res?.data?.bookings",
          res?.data?.bookings,
        );
        const formatted = res?.data?.bookings.map((item) => ({
          value: item.id,
          label: item.booking_code,
        }));
        setisuserBooking(formatted || []);
      }
    } catch (error) {
      console.error("Error fetching user booking:", error);
    }
  }, []);

  useEffect(() => {
    getLocationsList(2);
    userDropdownListGET();
    setValue("RequestedBy", admin_details?.name);
  }, []);
  // console.log("admin_details?.name", admin_details?.name);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderRadius: 4,
      border: "none",
      padding: 5,
      width: "100%",
      boxShadow: "none",
      minHeight: "initial",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999999",
    }),
  };
  // console.log("useData", useData);
  const onSubmit = async (data) => {
    // Build payload dynamically
    if (useData?.id) {
      console.log("SADAS", data);
      const value = {
        user_id: data?.Use[0]?.value || data?.Use?.value,
        amount: data?.WalletAmount,
        description: data?.Description,
        wallet_id: useData?.id,
        // user_id: 0,
        // amount: 0,
        // description: "string",
        // reference_id: 0,
      };

      // Only add `reference_id` if booking is selected
      if (data?.Booking?.value) {
        value.reference_id = data.Booking.value;
      }


      try {
        const res = await put(URLS.USER_WALLET_EDIT, value);
        console.log("documentupload", res);

        if (res?.status === "success") {
          reset();
          navigate("/wallettransaction");
          toast.success("Transaction Wallet Added Successfully");
        } else {
          toast.error(res?.message || "Failed to add wallet transaction");
        }
      } catch (error) {
        console.error("Error submitting transaction:", error);
        // toast.error("Something went wrong!");
      }
    } else {
      const value = {
        user_id: data?.Use?.value,
        amount: data?.WalletAmount,
        description: data?.Description,
      };

      // Only add `reference_id` if booking is selected
      if (data?.Booking?.value) {
        value.reference_id = data.Booking.value;
      }


      try {
        const res = await post(URLS.USER_WALLET_ADD, value);
        console.log("documentupload", res);

        if (res?.status === "success") {
          reset();
          navigate("/wallettransaction");
          toast.success("Transaction Wallet Added Successfully");
        } else {
          toast.error(res?.message || "Failed to add wallet transaction");
        }
      } catch (error) {
        console.error("Error submitting transaction:", error);
        // toast.error("Something went wrong!");
      }
    }
  };

  const { state, city, Use, Reason } = watch();
  // console.log("state?.value", isReject);
  useEffect(() => {
    const stateId = state?.value || useData?.state_id;
    const cityId = city?.value || useData?.city_id;
    const userId = Use?.value || useData?.user_id;
    if (stateId && cityId && userId) {
      userBookingDropdown({
        state: stateId,
        city: cityId,
        user: userId,
      });
    }
  }, [state, city, Use, useData]);

  useEffect(() => {
    setValue("state", [{ label: useData?.state, value: useData?.state }]);
    setValue("city", [{ label: useData?.city, value: useData?.city }]);
    setValue("Use", [{ label: useData?.user_name, value: useData?.user_id }]);
    setValue("Booking", [
      { label: useData?.booking_code, value: useData?.booking_code },
    ]);
    setValue("WalletAmount", useData?.amount);
    setValue("RequestedBy", admin_details?.name);
    setValue("Description", useData?.description);
    setValue("Reason", useData?.reason);
    setShowReason(isReject ? true : false);
  }, [useData, isReject]);

  // console.log("Submitted:", useData);
  const accept = async () => {
    setShowReason(false);

    let update = [useData?.id];
    if (update.length == 0) {
      toast.error("Kindly choose a Wallet ID");
      return;
    }
    // console.log("OWNER_accept", update.length);
    try {
      const payload = {
        wallet_ids: update,
      };
      console.log("UADSDPSADP", payload);

      const res = await post(`${URLS.USER_WALLET_ACCEPT}`, payload);
      //   console.log("res admin list", res);
      if (res.status == "success") {
        toast.success("Accept the User");
        navigate("/wallettransaction", {
          state: { type: "approved" },
        });
      }
    } catch (err) {
      console.log("err", err);
      // setOwners([]);
    }
  };
  const reject = async () => {
    let update = [useData?.id];

    if (Reason == null) {
      toast.error("Kindly added a Reject Reason");
      return;
    }
    try {
      const payload = {
        wallet_ids: update,
        reason: Reason,
      };
      console.log("UADSDPSADP", payload);

      const res = await post(`${URLS.USER_WALLET_REJECT}`, payload);
      if (res.status == "success") {
        toast.success("Reject The User");
        navigate("/wallettransaction", {
          state: { type: "rejected" },
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  return (
    <>
      <Topbar header={"Wallet Transaction - User"} />
      <div className="row mt-5">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* State */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="state"
              rules={{ required: "State is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    State<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={locationList?.states}
                    placeholder="Select State"
                    isSearchable
                    onChange={(selected) => {
                      setLocationsList((prev) => ({ ...prev, cities: [] }));

                      if (selected?.value) getLocationsList(3, selected.value);
                      setValue("city", "");
                      field.onChange(selected); // Fixed: Actually call the function with the selected value
                    }}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode || formType === "edit"}
                  />
                  {errors.state && (
                    <p style={{ color: "red" }}>{errors.state.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* City */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="city"
              rules={{ required: "City is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    City<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={locationList?.cities}
                    placeholder="Select City"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode || formType === "edit"}
                  />
                  {errors.city && (
                    <p style={{ color: "red" }}>{errors.city.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Use */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="Use"
              rules={{ required: "Use is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    User<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={userSearch ? filteredUsers : UsersDropdown}
                    onInputChange={(value) => {
                      setUserSearch(value);
                    }}
                    onMenuScrollToBottom={() => {
                      setCurrentDropLimit((prev) => prev + 100);
                    }}
                    placeholder="Select Use"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode || formType === "edit"}
                  />
                  {errors.Use && (
                    <p style={{ color: "red" }}>{errors.Use.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          {/* Booking */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="Booking"
              // rules={{ required: "Booking is required" }} // <-- commented out, so it's optional
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Booking Id (optional)
                  </label>
                  <Select
                    {...field}
                    options={isuserBooking}
                    placeholder="Select Booking"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                </div>
              )}
            />
          </div>
          {/* Wallet */}

          <div className="col-md-5">
            <Controller
              control={control}
              name="WalletAmount"
              rules={{ required: "Wallet Amount is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Wallet Amount<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="WalletAmount"
                    disabled={isViewMode}
                    type="number"
                  />
                  {errors.WalletAmount && (
                    <p style={{ color: "red" }}>
                      {errors.WalletAmount.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="RequestedBy"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Requested By<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="WalletAmount"
                    disabled
                  />
                </div>
              )}
            />
          </div>

          <div className="col-md-11">
            <Controller
              control={control}
              name="Description"
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <div style={{ width: "95%" }}>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Description<span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    className="input-box"
                    placeholder="Text..."
                    {...field}
                    style={{ minHeight: "131px" }}
                    disabled={isViewMode}
                    maxLength={200}
                  />
                </div>
              )}
            />
            {errors.Description && (
              <p style={{ color: "red" }}>{errors.Description.message}</p>
            )}
          </div>

          {formType === "add" && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Add
              </button>
            </div>
          )}
          {setReject && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Update
              </button>
            </div>
          )}
          {formType === "edit" && !setReject && (
            <>
              <div className="col-lg-11 justify-content-start ">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Description<span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex as-js gap-5">
                  <button
                    type="button"
                    className="approve-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    // onClick={handleSubmit((data) => {
                    //   console.log("Approve Data:", data);
                    //   setShowReason(false);
                    // navigate("/wallettransaction", {
                    //   state: { type: "approved" },
                    // });
                    // })}
                    onClick={accept}
                  >
                    Approve
                  </button>

                  <button
                    type="button"
                    className="reject1-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      setShowReason(true);
                    }}
                  >
                    Reject
                  </button>
                </div>
              </div>
            </>
          )}
          {showReason && (
            <>
              <div className="col-md-11" ref={inputRef}>
                <Controller
                  control={control}
                  name="Reason"
                  rules={{ required: "Reason is required" }}
                  render={({ field }) => (
                    <div style={{ width: "95%" }}>
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Reason<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="input-box"
                        placeholder="Enter reason..."
                        {...field}
                        style={{ minHeight: "131px" }}
                      />
                      {errors.Reason && (
                        <p style={{ color: "red" }}>{errors.Reason.message}</p>
                      )}
                    </div>
                  )}
                />
              </div>
              {formType === "edit" && (
                <div
                  className="col-lg-11 justify-content-end d-flex"
                  style={{ width: "87%" }}
                >
                  <button
                    type="button"
                    className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    // onClick={handleSubmit((data) => {
                    //   console.log("Approve Data:", data);
                    // navigate("/wallettransaction", {
                    //   state: { type: "rejected" },
                    // });
                    // })}
                    onClick={reject}
                  >
                    Submit
                  </button>
                </div>
              )}
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default WalletTransactionadd;
